import { steps } from './steps';
import { type QuestionnaireData, type SelectedData } from './types';

export const getOnboardingTranslateKey = (questionId: string, ...section: string[]) =>
  `components.onboarding.questionnaire.questions.${questionId}.${section.join('.')}`;

export const transformData = (data: SelectedData): QuestionnaireData => {
  const output: QuestionnaireData = {};

  steps.forEach((step) => {
    const stepId = step.id;
    const stepData = data[stepId];

    if (stepData === undefined) {
      return;
    }

    const selectedOption = stepData.option;

    output[stepId] = selectedOption; // It is only string[] on MultiText

    if (step.data.other && selectedOption === 'other') {
      // Before this was a boolean field and some analytics tools like Pendo were already capturing it as a boolean
      // field. As we've changed it to be a string field, the data type on those tools wouldn't update leading to
      // not being able to see the value of the property.
      // See https://knack.atlassian.net/browse/GT-127 for reference
      const propertyName = stepId === 'industry' ? 'industry_other_input' : `${stepId}_other`;

      output[propertyName] = stepData?.other ?? '';
    }
  });

  return output;
};
